export const environment = {
    production: false,
    apiBaseUrl: 'https://backend.staging.tablesense.com',
    cdnUrl: 'https://d1ytssun2732e8.cloudfront.net',
    landingPageBaseUrl: 'https://book.staging.tablesense.com',
    venueStorefrontBaseUrl: 'https://staging.tablesense.com',
    dojoBookingBaseUrl: 'https://dojo.staging.tablesense.com',
    teyaBookingBaseUrl: 'https://teya.staging.tablesense.com',
    marketingUrl: 'https://www.tablesense.com/?utm_source=customer_website&utm_medium=booking_channel&utm_campaign=customer_booking',
    newRelicApplicationId: '',
    privacyPolicyURL: 'https://tablesense.com/privacy-policy',
    getDirectionsURL: 'https://www.google.com/maps/search/?api=1&query=',
    googleMapsApiKey: 'AIzaSyA4byHd5co4AggOiEu4hMqZXl4pmMpeTsU',
    stripePublishableKey: 'pk_test_51LwP0cEM5WnAQPYGeIR7UNiJs2HDe5XhBM4iqa05NzPP3CoCXfrmbsBDgcpgOheIZYEtLQ9qLEieCKohygVbNjRM00MQ9ZfOJh',
    ryftPublicKey: 'pk_sandbox_Fd5R3cBFyEB9fUWOJdZ24yLkxUvDa6g2bzBY1VGdGFU5WMePsGBS1ve5Tb5IDz4O',
}
